import React, {Fragment} from 'react';

import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {Box, Grid, Typography} from '@material-ui/core';

import {InferPropTypes} from 'commons/types/Types';
import {data} from 'commons/defaults/legal-representantives';
import {AddressProofValues, Bullet} from 'commons/models';
import EfeDragAndDrop from 'components/efe-drag-and-drop/EfeDragAndDrop';
import {
    EfeBulletList,
    EfeButtonPrimary,
    EfeErrorMsg,
    EfeLink,
    EfeModal,
    EfeSupportMessage,
} from 'components';
import {FileWithPath} from 'react-dropzone';
import PropTypes from 'prop-types';
import {PersonTypes} from 'commons/constants';

InnerFormRepresentativePower.propTypes = {
    foreign: PropTypes.bool.isRequired,
    personType: PropTypes.string.isRequired,
};

/* eslint-disable react/jsx-handler-names */
function InnerFormRepresentativePower(
    props: InferPropTypes<
        typeof InnerFormRepresentativePower.propTypes & FormikProps<AddressProofValues>
    >
) {
    const bullets: Array<Bullet> = data;

    const {isSubmitting, values, setFieldValue, errors, personType, foreign} = props;

    const [open, setOpen] = React.useState<boolean>(false);

    const [uploadedFiles, setUploadedFiles] = React.useState<Array<FileWithPath>>([]);

    function uploadFile(file: FileWithPath) {
        if (file) {
            setUploadedFiles([file]);
            const reader = new FileReader();
            reader.onload = () => {
                setFile(reader.result ? reader.result : '');
            };
            reader.readAsDataURL(file);
        }
    }

    React.useEffect(() => {
        if(values && values.file) {
            try {
                const file = new File([values.file], 'poder-notarial');
                const filePath = {...file};
                filePath.size = file.size;
                filePath.name = file.name;
                setUploadedFiles([filePath]);
            } catch (error) {
                console.error(error);
            }
        }
    }, [values]);

    function deleteFile(index: number) {
        if (uploadedFiles && uploadedFiles.length) {
            uploadedFiles.splice(index, 1);
            const aux = [...uploadedFiles];
            setUploadedFiles(aux);
            setFieldValue('file', '');
        }
    }

    function setFile(file: string | ArrayBuffer) {
        setFieldValue('file', file);
    }

    function handleOpenClose() {
        setOpen(!open);
    }

    return (
        <Fragment>
            <EfeModal
                open={open}
                title={'Requisitos'}
                reactElement={<EfeBulletList bullets={bullets} />}
                handleAction={handleOpenClose}
            />
            <Form noValidate>
                <Box m={2}>
                    <EfeSupportMessage />
                    <Box mt={4} mb={2}>
                        <Typography variant='body2' color='textPrimary'>
                            {PersonTypes.MORAL === personType && foreign
                                ? 'Testimonio o copia certificada del instrumento expedido por fedatario p\u00FAblico.'
                                : 'Sube el poder notarial en la ventana a continuaci\u00F3n'}
                        </Typography>
                    </Box>
                    <Box mt={2} mb={4}>
                        <EfeLink
                            onClick={handleOpenClose}
                            variant='body2'
                            color='secondary'
                            underline='always'
                            bold={true}
                            content={'Requerimientos'}
                        />
                    </Box>

                    <EfeDragAndDrop
                        maxSizeFile={25}
                        numFiles={1}
                        file={values.file}
                        fileList={uploadedFiles}
                        deleteFile={deleteFile}
                        loadFile={uploadFile}
                    />
                    {errors.file && (
                        <Box>
                            <EfeErrorMsg message={errors.file} />
                        </Box>
                    )}
                    <Grid container direction='row' justifyContent='flex-end'>
                        <Box pt={6} width={160}>
                            <EfeButtonPrimary
                                fullWidth
                                disabled={isSubmitting}
                                type='submit'
                                endIcon={<CallMade />}>
                                {'OK'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Box>
            </Form>
        </Fragment>
    );
}

export default InnerFormRepresentativePower;
